import { IPerfilTipoCliente } from "../../../Interfaces/Geral/CadastroEEditaTipoCliente/CadastroEEditaTipoClienteInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarPerfilTipoContaService() {
    return Service(
        Axios.get<Array<IPerfilTipoCliente>>(
            `/home/perfiltipoconta/listarperfiltipocontas`
        )
    );
}

export async function GetPerfilTipoContaService(idPerfilTipoConta: number) {
    return Service(
        Axios.get<IPerfilTipoCliente>(
            `/home/perfiltipoconta/getperfiltipoconta?idPerfilTipoConta=${idPerfilTipoConta}`
        )
    );
}

export async function CadastrarPerfilTipoContaService(
    data: IPerfilTipoCliente
) {
    return Service(
        Axios.post(`/home/perfiltipoconta/cadastrarperfiltipoconta`, data)
    );
}

export async function AtualizarPerfilTipoContaService(
    data: IPerfilTipoCliente
) {
    return Service(
        Axios.put(`/home/perfiltipoconta/atualizarperfiltipoconta`, data)
    );
}

export async function DeletarPerfilTipoContaService(idPerfilTipoConta: number) {
    return Service(
        Axios.delete(
            `/home/perfiltipoconta/removerperfiltipoconta?idPerfilTipoConta=${idPerfilTipoConta}`
        )
    );
}
